const common = {
  borderColor: '#ececec',
  darkerBorderColor: '#ececec',
  treeWidth: 250,
  treeClosedWidth: 31,
  headerHeight: 69,
  navbarHeight: 46,
  swiftMenuWidth: 44,
  metaMenuWidth: 260,
  nodeMenuWidth: 240,
  footerHeight: 35,
  bannerHeight: '45%'
}

export default common



// WEBPACK FOOTER //
// ./src/styles/common.js